import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { Button, CssBaseline, TextField, Link, Grid, Typography, List, ListItem } from '@material-ui/core';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import ToastStr from '../../request/toastStr';
import { Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@material-ui/core';

import axios from 'axios';

import { COLORS } from '../../shared/Theme';
import { SIcon } from '../../shared/Icon';

import { admin as v_admin, basic, Values, SNACKBAR_TIME, edu } from '../../request/values';
import { useSnackbar } from 'notistack';
import AudioPlayer from '../../components/AudioPlayer';

const SERVER = basic.server;

const useStyles = makeStyles((theme: any) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	container1: {
		padding: 0,
		height: '85vh',
		marginTop: '15vh',
	},
	container2: {
		padding: 0,
		display: 'grid',
		gridTemplateRows: '1fr 2.5fr 6fr 1fr 1fr',
		width: '100%',
		height: '98vh',
		marginTop: '2vh',
	},
	playImage: {
		width: '50%',
	},
	playImageSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '30vw', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	logoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		//marginBottom: '10vh',
		margin: '3vh 0',
	},
	logobutton: {
		border: 'none',
		backgroundColor: 'transparent',
	},
	buttonFont: {
		//color: `${COLORS.WHITE}`,
		fontSize: '2vw',
	},
	border: {
		borderWidth: 5,
		borderStyle: 'solid',
		borderColor: `#000000`,
		background: `${COLORS.WHITE}`,
		padding: '1vw',
		marginTop: '1vh',
	},
	inputTime: {
		//borderColor: 'black',
		//borderRadius: '10px',
		width: '12vw',
		height: '10vh',
		fontSize: '3vw',
		textAlign: 'center',
		outline: 'none',
	},
	typeNum: {
		//borderColor: 'black',
		//borderRadius: '10px',
		width: '14vw',
		height: '8vh',
		fontSize: '2.5vw',
		textAlign: 'center',
		outline: 'none',
	},
	timeSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		marginTop: '15vh',
	},
	timerSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		fontSize: '3vw',
		marginBottom: '10vh',
		margin: '0 auto',
	},
	rankingTimerSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		fontSize: '1.4vw',
		color: `${COLORS.WHITE}`,
		borderWidth: 5,
		borderStyle: 'solid',
		borderColor: `${COLORS.WATER_BLUE}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: 25,
		padding: '10px',
		width: '100%',
		height: '80%',
		margin: '2vh auto',
	},
	playButton: {
		width: '10vw',
		height: '10vh',
		marginLeft: '2vw',
		alignItems: 'center',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		color: `${COLORS.WHITE}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			color: `${COLORS.PUMPKIN}`,
			backgroundColor: `${COLORS.WHITE}`,
			//bolder: 'none',
			//boxShadow: 'none',
		},
	},
	playButtonImage: {
		fontSize: '1.7vw',
	},
	inputSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		fontWeight: 'bold',
		fontFamily: 'NanumB',
		marginTop: '1vh',
	},
	typeRatio: {
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		fontFamily: 'NanumB',
		margin: '2vh',
	},
	hideTimeInput: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		marginTop: '3vh',
	},
	timerFont: {
		fontSize: '100%',
		fontWeight: 'bold',
		fontFamily: 'NanumB',
	},
	trophySection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: '5vh 0',
	},
	ExceptWinner: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
		width: '10vh',
		height: '9vh',
		marginBottom: 17,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '8vh',
			height: 'auto',
		},
	},
	Winner: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
		width: '15vh',
		height: '13vh',
		marginRight: 60,
		marginLeft: 60,
		marginBottom: 17,

		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '13vh',
			height: 'auto',
		},
	},
	tableHeader: {
		width: '100vw',
		height: 'auto',
		// backgroundColor: `${COLORS.PUMPKIN}`,
		// background: `url("/images/ranking/header.webp")`,
		// objectFit: 'contain',
		// borderRadius: 10,
		// boxShadow: '1px 3px 6px 1px rgba(0, 0, 0, 0.16)',
	},
	tableHeaderRow: {
		width: '90vw',
		height: '5vh',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: 10,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
	},
	headerCell: {
		fontSize: '2.3vh',
		// borderRadius: 10,
		// boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
	},

	tableContent: {
		height: 80,
		borderBottom: 'none',
		fontSize: '2.3vh',
		fontFamily: 'NanumB',
	},
	winnerContent: {
		'& th, td': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		//height: '50vh',
		margin: '1% 3%',
		backgroundColor: 'transparent',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '1fr 4fr 2fr 10px 2fr 10px 2fr',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			//background: 'none',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '2.3vh',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
	},
	memberInfo: {
		display: 'grid',
		gridTemplateColumns: '1fr 4fr 2fr 10px 2fr 10px 2fr',
		padding: '20px 0',
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: '2.8vh',
		fontFamily: 'NanumB',
		lineHeight: '21px',
	},
	blank: {
		height: '40px',
	},
	footer: {
		textAlign: 'center',
		marginTop: '3vh',
		//marginBottom: '5vh',
		'& img': {
			width: 166,
		},
	},
	playStartUpLogoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',

		margin: 'auto 0',
		//marginRight: '-11vw',
		'& img': {
			width: '25vw',
			height: 'auto',
		},
	},
	upperSection: {
		display: 'grid',
		gridTemplateColumns: '1fr 4fr 1fr',
	},
	infoButton: {
		//borderWidth: 2,
		//borderStyle: 'solid',
		//borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '30vw',
		'&:hover': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	endingSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	endingText: {
		fontSize: '3vw',
		fontWeight: 'bold',
		marginBottom: '10vw',
	},
	song_container: {
		position: 'fixed',
		float: 'left',
		marginTop: '5vh',
		marginLeft: '5vw',
		/*    box-shadow: 0px 0px 5px 1px gray;*/
		borderRadius: '20px',
		width: '150px',
		height: '100px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '10px',
	},
	song_button: {
		background: 'none',
		border: '0px',
		width: '50px',
	},
}));

const SubAdminClassRun: React.FC<any> = (props) => {
	const classes = useStyles();

	const [hours, setHours] = useState<any | null>();
	const [minutes, setMinutes] = useState<any | null>();
	const [seconds, setSeconds] = useState<any | null>();

	const [nowHours, setNowHours] = useState<any | null>();
	const [nowMin, setNowMin] = useState<any | null>();
	const [nowSec, setNowSec] = useState<any | null>();

	const [endHours, setEndHours] = useState<any | null>();
	const [endMin, setEndMin] = useState<any | null>();
	const [endSec, setEndSec] = useState<any | null>();

	const [hideTime, setHideTime] = useState<any>(20);

	const [mTypeNum, setMTypeNum] = useState<any>(0);
	const [dTypeNum, setDTypeNum] = useState<any>(0);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	let now = new Date();

	const [rank, setRank] = useState([
		{
			company_name: '테스트',
			stock: 180000,
			loan: 0,
			loan_interest: 0,
			capital: 180000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
		{
			company_name: '테스트1',
			stock: 190000,
			loan: 0,
			loan_interest: 0,
			capital: 190000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
		{
			company_name: '테스트2',
			stock: 200000,
			loan: 0,
			loan_interest: 0,
			capital: 200000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
	]);

	const [timerFlag, setTimerFlag] = useState<any | null>(false);
	const history = useHistory();
	const { member } = props;

	const state: any = history.location.state;
	const classCode = state.code;
	const className = state.name;

	const songs = [
		'../bgm/funny-and-clumsy.mp3',
		'../bgm/innovation-vision-corporate.mp3',
		'../bgm/inspiring-epic-dubstep.mp3',
		'../bgm/radiant-horizons.mp3',
		'../bgm/summer-adventures.mp3',
		'../bgm/summer-dance-party.mp3',
		'../bgm/summer-dance-spark.mp3',
		'../bgm/sunrise-groove.mp3',
		'../bgm/sunshine.mp3',
		'../bgm/upbeat-acoustic.mp3',
	];

	const songs_name = [
		'funny clumsy',
		'innovation vision',
		'inspiring epic',
		'radiant horizon',
		'summer adventures',
		'summer dance party',
		'summer dance spark',
		'sunrise groove',
		'sunshine',
		'upbeat acoustic',
	];

	const [playingSrc, setPlayingSrc] = useState<string | null>(null);
	const [currentSongIndex, setCurrentSongIndex] = useState<number>(0);

	const handleSongEnd = () => {
		console.log('노래가 끝났습니다.');
		setCurrentSongIndex((prevIndex) => (prevIndex + 1) % songs.length);
	};

	const handlePlay = (src: string) => {
		console.log('play: ', src);
		// 현재 재생 중인 오디오가 있고, 다른 오디오로 변경하는 경우
		if (playingSrc && playingSrc !== src) {
			setPlayingSrc(null); // 현재 재생 중인 오디오 중지
			setTimeout(() => setPlayingSrc(src), 100); // 새로운 오디오로 변경
		} else {
			setPlayingSrc(playingSrc === src ? null : src);
		}
	};
	const handlePrevSong = () => {
		setCurrentSongIndex((prevIndex) => (prevIndex === 0 ? songs.length - 1 : prevIndex - 1));
	};

	const handleNextSong = () => {
		setCurrentSongIndex((prevIndex) => (prevIndex + 1) % songs.length);
	};

	// 곡 재생 및 중지
	useEffect(() => {
		const song = songs[currentSongIndex];
		setPlayingSrc(song);
	}, [currentSongIndex]);

	useEffect(() => {
		console.log('seconds: ', seconds);
		if (hours <= 0 && minutes <= 0 && seconds <= 0) {
			console.log('end song');
			setPlayingSrc(null); // 오디오 중지
		}
	}, [hours, minutes, seconds]);

	useEffect(() => {
		console.log('seconds2:', seconds);
		const countdown = setInterval(() => {
			setNowHours(now.getHours());
			setNowMin(now.getMinutes());
			setNowSec(now.getSeconds());

			let et = parseInt(endHours) * 3600 + parseInt(endMin) * 60 + parseInt(endSec);
			let nt = parseInt(nowHours) * 3600 + parseInt(nowMin) * 60 + parseInt(nowSec);
			let temp = et - nt;

			setHours(Math.floor(temp / 3600));
			temp = temp % 3600;
			setMinutes(Math.floor(temp / 60));
			temp = temp % 60;
			setSeconds(temp);
		}, 1000);
		return () => clearInterval(countdown);
	}, [nowHours, nowMin, nowSec]);

	const setEndTime = (event: any) => {
		console.log(endHours);
		if (endHours == null || endMin == null) {
			enqueueSnackbar(ToastStr.CLASS_END_TIME_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else if (mTypeNum === 0) {
			enqueueSnackbar(ToastStr.CLASS_TYPE_NUM_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else {
			postClassTypeRatio();
			let et = parseInt(endHours) * 3600 + parseInt(endMin) * 60 + parseInt(endSec);
			let nt = parseInt(nowHours) * 3600 + parseInt(nowMin) * 60 + parseInt(nowSec);
			let temp = et - nt;
			console.log(et + ' ' + nt);

			setHours(Math.floor(temp / 3600));
			temp = temp % 3600;
			setMinutes(Math.floor(temp / 60));
			temp = temp % 60;
			setSeconds(temp);

			setTimerFlag(true);
		}
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;

		const values = value.replace(/[^0-9]/g, '');
		if (id === 'hours') {
			setEndHours(values);
			setEndSec(0);
		} else if (id === 'minutes') {
			setEndMin(values);
			setEndSec(0);
		} else if (id === 'hideTime') {
			setHideTime(values);
		} else if (id === 'dType') {
			setDTypeNum(values);
		} else if (id === 'mType') {
			setMTypeNum(values);
		}
	};

	const AddComma = (num: number) => {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	};

	const postClassTypeRatio = () => {
		let url = new URL(basic.server + v_admin.admin + v_admin.type_update);
		axios({
			method: 'POST',
			withCredentials: true,
			url: url.toString(),
			data: {
				classCode: classCode,
				mTypeNum: mTypeNum,
				dTypeNum: dTypeNum,
			},
		})
			.then((res) => res.data)
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar('클래스를 시작했습니다.', {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.FAIL_CODE) {
					if (data.msg)
						enqueueSnackbar(data.msg, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					else
						enqueueSnackbar('클래스 시작에 실패했습니다.', {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
				} else {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'error' });
					else
						enqueueSnackbar('클래스 시작 과정에서 오류가 발생했습니다.', {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
				}
			});
	};

	const getRankContent = () => {
		axios({
			method: 'POST',
			data: {
				class_code: classCode,
			},
			withCredentials: true,
			url: SERVER + edu.path + edu.class_rank_content,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setRank(data.rank);
				} else {
				}
			});
	};

	useEffect(() => {
		getRankContent();
		const tick = setInterval(() => {
			getRankContent();
		}, 1000 * 15);
		return () => clearTimeout(tick);
	}, []);

	const movePage = () => {
		history.push({
			pathname: '/subAdminOpenRanking',
			state: {
				// location state
				code: classCode,
				name: className,
			},
		});
	};

	if (hours <= 0 && minutes <= 0 && seconds <= 0 && timerFlag === true) {
		return (
			<div className={classes.background}>
				<Container component="main" className={classes.container1}>
					<CssBaseline />
					<div className={classes.endingSection}>
						<Typography className={classes.endingText}>플레이스타트업이 종료되었습니다!</Typography>
						<Button onClick={(e) => movePage()} className={classes.infoButton}>
							<Typography className={classes.buttonFont}>순위 공개</Typography>
						</Button>
					</div>
				</Container>
			</div>
		);
	} else if (hours != null && minutes != null && seconds != null && timerFlag === true) {
		if (hours == 0 && minutes < parseInt(hideTime)) {
			return (
				<div className={classes.background}>
					<div className={classes.song_container}>
						<div style={{ color: '#fcab59', fontWeight: 'bold', fontSize: '20px' }}>플레이리스트</div>
						<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
							<button onClick={handlePrevSong} className={classes.song_button}>
								<img src={'../images/backward_button.png'} style={{ width: '80%' }}></img>
							</button>
							<AudioPlayer src={songs[currentSongIndex]} isPlaying={playingSrc === songs[currentSongIndex]} onPlay={handlePlay} onEnded={handleSongEnd}></AudioPlayer>
							<button onClick={handleNextSong} className={classes.song_button}>
								<img src={'../images/forward_button.png'} style={{ width: '80%' }}></img>
							</button>
						</div>
						<span>
							{currentSongIndex + 1}. {songs_name[currentSongIndex]}
						</span>
					</div>

					<Container component="main" className={classes.container2}>
						<CssBaseline />
						<div className={classes.timerSection}>
							<Typography className={classes.timerFont}>남은 시간</Typography>
							<Typography className={classes.timerFont}>
								{hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
							</Typography>
						</div>
						<div className={classes.playImageSection}>
							<img className={classes.playImage} src="/images/playImage.png" />
						</div>
						<div className={classes.logoSection}>
							<SIcon type="P" />
						</div>
					</Container>
				</div>
			);
		} else {
			return (
				<div className={classes.background}>
					<div className={classes.song_container}>
						<div style={{ color: '#fcab59', fontWeight: 'bold', fontSize: '20px' }}>플레이리스트</div>
						<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
							<button onClick={handlePrevSong} className={classes.song_button}>
								<img src={'../images/backward_button.png'} style={{ width: '80%' }}></img>
							</button>
							<AudioPlayer src={songs[currentSongIndex]} isPlaying={playingSrc === songs[currentSongIndex]} onPlay={handlePlay} onEnded={handleSongEnd}></AudioPlayer>
							<button onClick={handleNextSong} className={classes.song_button}>
								<img src={'../images/forward_button.png'} style={{ width: '80%' }}></img>
							</button>
						</div>
						<span>
							{currentSongIndex + 1}. {songs_name[currentSongIndex]}
						</span>
					</div>

					<Container component="main" className={classes.container2}>
						<CssBaseline />
						<div className={classes.upperSection}>
							<div></div>
							<div className={classes.playStartUpLogoSection}>
								<img src="/images/ranking/logo.webp" />
							</div>
							<div className={classes.rankingTimerSection}>
								<Typography className={classes.timerFont}>남은 시간</Typography>
								<Typography className={classes.timerFont}>
									{hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
								</Typography>
							</div>
						</div>

						<div className={classes.trophySection}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									textAlign: 'center',
								}}
							>
								<Box className={classes.ExceptWinner}>
									<img src="/images/ranking/silver.webp" />
								</Box>
								<Typography style={{ fontSize: '2.6vh', width: '10vh' }}>{rank[1] != undefined ? rank[1].company_name : ''}</Typography>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									textAlign: 'center',
								}}
							>
								<Box className={classes.Winner}>
									<img src="/images/ranking/gold.webp" />
								</Box>
								<Typography style={{ fontSize: '3.5vh' }}>{rank[0] != undefined ? rank[0].company_name : ''}</Typography>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									textAlign: 'center',
								}}
							>
								<Box className={classes.ExceptWinner}>
									<img src="/images/ranking/bronze.webp" />
								</Box>
								<Typography style={{ fontSize: '2.6vh', width: '10vh' }}>{rank[2] != undefined ? rank[2].company_name : ''}</Typography>
							</div>
						</div>

						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>순위</Typography>
								</span>
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>기업명</Typography>
								</span>
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>자산</Typography>
								</span>
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>-</Typography>
								</span>
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>부채</Typography>
								</span>
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>=</Typography>
								</span>
								<span>
									<Typography style={{ fontSize: '2.8vh' }}>자본</Typography>
								</span>
							</div>
							<List id="classinfo">
								{rank != null &&
									rank.map((item: any, index: number) => {
										return (
											<AppListItem
												index={index}
												name={item.company_name}
												stock={item.stock}
												loan={item.loan}
												loan_interest={item.loan_interest}
												capital={item.capital}
												material_stock={item.material_stock}
												material_loan_stock={item.material_loan_stock}
												license_stock={item.license_stock}
											/>
										);
									})}
								<div className={classes.blank}></div>
							</List>
						</div>

						<div className={classes.footer}>
							<img src="/images/youstarter.png" />
						</div>

						<div className={classes.logoSection}>
							<SIcon type="P" />
						</div>
					</Container>
				</div>
			);
		}
	} else {
		return (
			<div className={classes.background}>
				<Container component="main" className={classes.container1}>
					<CssBaseline />
					<div className={classes.inputSection}>
						플레이 종료 시각을 설정하세요
						<div className={classes.timeSection}>
							<input id="hours" className={classes.inputTime} onChange={valueChangeHandler} type="text"></input>:
							<input id="minutes" className={classes.inputTime} onChange={valueChangeHandler} type="text"></input>
							<Button fullWidth variant="contained" className={classes.playButton} onClick={(e) => setEndTime(e)}>
								<Typography className={classes.playButtonImage}>PLAY!</Typography>
							</Button>
						</div>
					</div>
					<div className={classes.hideTimeInput}>
						<input id="hideTime" className={classes.inputTime} onChange={valueChangeHandler} placeholder="20" type="text"></input>
						분전 가리겠습니다
					</div>

					<div className={classes.inputSection}>
						<div className={classes.typeRatio}>제조기업 : 유통기업</div>
						<div>
							<input id="mType" className={classes.typeNum} onChange={valueChangeHandler} placeholder="제조기업수" type="text"></input>:
							<input id="dType" className={classes.typeNum} onChange={valueChangeHandler} placeholder="유통기업수" type="text"></input>
						</div>
					</div>
				</Container>
			</div>
		);
	}
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, name, stock, loan, loan_interest, capital, material_stock, material_loan_stock, license_stock } = props;
	const AddComma = (num: number) => {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	};

	return (
		<ListItem id={index} className={classes.memberInfo}>
			<Box className={classes.buttonLabel}>{index + 1}</Box>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{AddComma(stock + material_stock + license_stock) + '원'}</Box>
			<Box></Box>
			<Box className={classes.buttonLabel}>{AddComma(loan + loan_interest + material_loan_stock) + '원'}</Box>
			<Box></Box>
			<Box className={classes.buttonLabel}>{AddComma(capital + license_stock) + '원'}</Box>
		</ListItem>
	);
};

export default SubAdminClassRun;
